import { motion } from 'framer-motion';

const ProfilePage = () => {
  return (
    <div className="h-[90vh] text-white overflow-hidden md:overflow-hidden overflow-y-auto">
      {/* Hero Section */}
      <section className="relative h-full flex items-center justify-center px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center h-full py-8">
          
          {/* Left Side - Text Content */}
          <motion.div
            className="space-y-4 lg:space-y-8"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {/* Brutalist Header Block */}
            <div className="relative">
              <div className="absolute -top-2 lg:-top-4 -left-2 lg:-left-4 w-full h-full bg-white/10 border-2 lg:border-4 border-white"></div>
              <div className="relative bg-black border-2 lg:border-4 border-white p-4 lg:p-8">
                <h1 style={{ fontSize: 'clamp(2.5rem, 8vw, 6rem)' }} className="font-black leading-none tracking-tighter">
                  CHADDIX
                  <br />
      
                </h1>
              </div>
            </div>

            {/* Subtitle Block */}
            <div className="bg-white text-black p-3 lg:p-6 border-2 lg:border-4 border-white transform rotate-1">
              <p style={{ fontSize: 'clamp(0.875rem, 1.5vw, 1.25rem)' }} className="font-bold uppercase tracking-wide">
                CO-FOUNDER • HEAD OF POST • FIXER OF ALL THINGS
              </p>
            </div>

            {/* Description */}
            <div className="space-y-2 lg:space-y-4">
              <div className="h-1 lg:h-2 w-12 lg:w-20 bg-white"></div>
              <p style={{ fontSize: 'clamp(0.875rem, 1.2vw, 1.125rem)' }} className="leading-relaxed font-medium">
              AdFed’s mission of supporting and celebrating makers resonates with me shockingly well. “Made for those who make” isn’t just a tagline—it’s how I operate.
              </p>
            </div>
          </motion.div>

          {/* Right Side - Photo */}
          <motion.div
            className="relative flex justify-center lg:justify-end"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {/* Brutalist Photo Frame */}
            <div className="relative max-w-sm lg:max-w-2xl">
              {/* Background geometric shapes */}
              <div className="absolute -top-4 lg:-top-8 -right-4 lg:-right-8 w-16 lg:w-36 h-16 lg:h-36 bg-white transform rotate-45"></div>
              <div className="absolute -bottom-4 lg:-bottom-8 -left-4 lg:-left-8 w-12 lg:w-24 h-12 lg:h-24 bg-white/20 border-2 lg:border-4 border-white"></div>
              
              {/* Main photo container */}
              <div className="relative bg-white p-1 lg:p-2 border-4 lg:border-8 border-white transform -rotate-2">
                <div className="bg-black p-1 lg:p-2">
                  <img
                    src="/adfed-pic.png"
                    alt="Chad - Digital Strategist"
                    className="w-full h-auto grayscale contrast-125"
                  />
                </div>
              </div>
              
              {/* Overlay text strip */}
              <div className="absolute bottom-2 lg:bottom-4 left-2 lg:left-4 right-2 lg:right-4 bg-black border-1 lg:border-2 border-white p-2 lg:p-3">
                <p style={{ fontSize: 'clamp(0.625rem, 1vw, 0.875rem)' }} className="text-white font-black uppercase tracking-widest text-center">
                  DECENT WITH TECH • PRETTY MEH WITH PEOPLE
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ProfilePage; 